import axios from "axios";
import myAppConfig from "../../config";

// Récupérer tous les espaces de candidature
const getSpaces = () => {
  return axios
    .get(myAppConfig.api.ENDPOINT + "/api/v1/copilot/spaces/", { withCredentials: true })
    .then((response) => {
      return response;
    });
};

// Créer un nouvel espace
const createSpace = (name) => {
  const formData = new FormData();
  formData.append("name", name);
  
  return axios
    .post(myAppConfig.api.ENDPOINT + "/api/v1/copilot/spaces/", formData, { 
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })
    .then((response) => {
      return response;
    });
};

// Récupérer un espace spécifique
const getSpace = (spaceId) => {
  return axios
    .get(myAppConfig.api.ENDPOINT + `/api/v1/copilot/spaces/${spaceId}`, { withCredentials: true })
    .then((response) => {
      return response;
    });
};

// Récupérer la tarification courante
const getPricing = () => {
  return axios
    .get(myAppConfig.api.ENDPOINT + `/api/v1/copilot/pricing`, { withCredentials: true })
    .then((response) => response);
};

// Mettre à jour la tarification (réservé admin)
const updatePricing = (cfg) => {
  return axios
    .post(myAppConfig.api.ENDPOINT + `/api/v1/copilot/pricing`, cfg, { withCredentials: true })
    .then((response) => response);
};

// Supprimer un espace
const deleteSpace = (spaceId) => {
  return axios
    .delete(myAppConfig.api.ENDPOINT + `/api/v1/copilot/spaces/${spaceId}`, { withCredentials: true })
    .then((response) => {
      return response;
    });
};

// Uploader un document
const uploadDocument = (spaceId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  
  return axios
    .post(myAppConfig.api.ENDPOINT + `/api/v1/copilot/spaces/${spaceId}/documents`, formData, { 
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })
    .then((response) => {
      return response;
    });
};

// Supprimer un document
const deleteDocument = (documentId) => {
  return axios
    .delete(myAppConfig.api.ENDPOINT + `/api/v1/copilot/documents/${documentId}`, { withCredentials: true })
    .then((response) => {
      return response;
    });
};

// Analyser les documents d'un espace
const analyzeDocuments = (spaceId) => {
  return axios
    .post(myAppConfig.api.ENDPOINT + `/api/v1/copilot/spaces/${spaceId}/analyze`, {}, { withCredentials: true })
    .then((response) => {
      return response;
    });
};

// Récupérer les messages d'un espace
const getMessages = (spaceId) => {
  return axios
    .get(myAppConfig.api.ENDPOINT + `/api/v1/copilot/spaces/${spaceId}/messages`, { withCredentials: true })
    .then((response) => {
      return response;
    });
};

// Envoyer un message
const sendMessage = (spaceId, message, usesContext = true) => {
  return axios
    .post(myAppConfig.api.ENDPOINT + `/api/v1/copilot/spaces/${spaceId}/chat`, {
      space_id: spaceId,
      user_id: 0, // Sera rempli par le backend
      message: message,
      role: "user",
      uses_context: usesContext
    }, { withCredentials: true })
    .then((response) => {
      return response;
    });
};

// Réessayer l'embedding d'un document en erreur
const retryDocument = (documentId) => {
  return axios
    .post(myAppConfig.api.ENDPOINT + `/api/v1/copilot/documents/${documentId}/retry`, {}, { withCredentials: true })
    .then((response) => {
      return response;
    });
};

const CopilotService = {
  getSpaces,
  createSpace,
  getSpace,
  getPricing,
  updatePricing,
  deleteSpace,
  uploadDocument,
  deleteDocument,
  analyzeDocuments,
  getMessages,
  sendMessage,
  retryDocument
};

export default CopilotService;

